import { Card } from "../shared";

export function PaymentSettingsSection({ settings, setSettings, setPage }) {
  return (
    <Card style={{ marginBottom: 8 }}>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 16, marginBottom: 6 }}>💳 Payment Settings</div>
      <div style={{ fontSize: 12, color: "#9B9690", marginBottom: 16, lineHeight: 1.6 }}>
        Choose who pays the <strong>$2.95 Leasly platform fee</strong> when tenants pay rent online via Stripe.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {[
          { value: false, label: "Landlord absorbs fee",  desc: "Tenants pay rent only. You cover the $2.95 platform fee — they see a clean rent amount at checkout." },
          { value: true,  label: "Pass fee to tenant",    desc: "Tenants pay rent + $2.95 at checkout. Stripe processing fees still apply and are deducted before funds reach your account." },
        ].map(opt => (
          <label key={String(opt.value)} style={{
            display: "flex", alignItems: "flex-start", gap: 10,
            padding: "12px 14px",
            border: `1.5px solid ${settings.pass_fee_to_tenant === opt.value ? "#163C2F" : "#E8E4DC"}`,
            borderRadius: 10, cursor: "pointer",
            background: settings.pass_fee_to_tenant === opt.value ? "#EAF2ED" : "#fff",
            transition: "all 0.12s",
          }}>
            <input
              type="radio"
              name="pass_fee_to_tenant"
              checked={settings.pass_fee_to_tenant === opt.value}
              onChange={() => setSettings(s => ({ ...s, pass_fee_to_tenant: opt.value }))}
              style={{ marginTop: 2, accentColor: "#163C2F", flexShrink: 0 }}
            />
            <div>
              <div style={{ fontWeight: 700, fontSize: 13, color: "#163C2F" }}>{opt.label}</div>
              <div style={{ fontSize: 12, color: "#9B9690", marginTop: 3 }}>{opt.desc}</div>
            </div>
          </label>
        ))}
      </div>
      <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid #F0EDE6" }}>
        <button
          onClick={() => setPage("HelpFees")}
          style={{ background: "none", border: "none", padding: 0, cursor: "pointer", fontSize: 12, color: "#214D3A", fontFamily: "'Manrope', sans-serif", fontWeight: 600, textDecoration: "underline" }}
        >
          Understanding Leasly and Stripe fees →
        </button>
      </div>
    </Card>
  );
}
